import PropTypes from 'prop-types';
import React, { Children, type PropsWithChildren } from 'react';
import { useTabsContext } from '../Tabs';

export function TabList({ children }: PropsWithChildren<void>) {
  const { activeIndex, id, onSelectTab, onChange } = useTabsContext();
  return (
    <div data-testid="tablist" className="TabList" role="tablist">
      {Children.map(children, (child, index) =>
        React.cloneElement(child, {
          id: `${id}-tab-${index}`,
          'aria-controls': `${id}-panel-${index}`,
          isActive: index === activeIndex,
          onSelect: event => {
            event.preventDefault();
            onSelectTab(index);
            onChange?.({ index });
          },
        }),
      )}
    </div>
  );
}

TabList.displayName = 'TabList';
TabList.propTypes = {
  children: PropTypes.node,
};
